import {applyMiddleware, createStore} from 'redux';
import {routerMiddleware} from 'react-router-redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import {createLogger} from 'redux-logger';
import thunk from 'redux-thunk';
import reducer from './reducers/';
import createHistory from 'history/createBrowserHistory'
import {autoRehydrate} from 'redux-persist'

const history = createHistory();

const browserMiddleware = routerMiddleware(history);

const getMiddleware = () => {
  if (process.env.NODE_ENV === 'production') {
    return applyMiddleware(thunk, browserMiddleware);
  } else {
    // Enable additional logging in non-production environments.
    return composeWithDevTools(applyMiddleware(thunk, browserMiddleware, createLogger({ collapsed: true })), autoRehydrate());
  }
};

export default function configureStore(initialState) {
  let store =  createStore(reducer, initialState, getMiddleware());
  return store;
}



// WEBPACK FOOTER //
// ./src/store.js